<template>
	<div class="frame-page">
		<slot/>
	</div>
</template>

<script>
/**
 * 页面标题组件
 */
	export default {
		name: "AppContent",
		props: {
			title: String
		},
		data() {
			return {
				minHeight: (window.innerHeight - 102) + 'px'
			}
		},
		mounted() {
			window.document.title = '云财务 - ' + (this.title || this.$route.meta.title);
		}
	}
</script>

<style scoped>

</style>
